import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { Layout, Row, Col, Text } from '../../components/Boneyard';
import { ERROR_BANNER } from '../../../automationHooks.json';
import { useSSRQuery } from '../../graphql';
import ERROR_BANNER_TRANSLATION_QUERY from './errorBanner/errorBannerTranslations.query.graphql';

const Notification = styled(Layout.FullWidth)`
  margin-right: auto;
  margin-left: auto;
  margin-top: -1px;
  background: #e9baba;
  z-index: 0;
  color: #000;
  ${props => props.theme.query.md} {
    margin-top: ${props => (props.offsetTopPosition ? 1 : -1)}px;
  }
  ${props => props.theme.query.lg} {
    margin-top: ${props => (props.offsetTopPosition ? 1 : -1)}px;
  }
`;

const IconWrapper = styled(Col)`
  width: 35px;
  position: absolute;
  top: 50%;
  left: 1.7rem;
  transform: translate(-50%, -50%);
`;

const BillboardDisclaimerRow = styled(Row)`
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 calc(30px / 2);
`;

const BillboardDisclaimerText = styled.div`
  width: 100%;
  font-size: 0.7rem;
  font-weight: bold;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  padding: 1rem 0 1rem 2rem;
`;

const ErrorBanner = ({ icon, offsetTopPosition = false, errorMessage }) => {
  const errorBannerTranslations = useSSRQuery(ERROR_BANNER_TRANSLATION_QUERY);

  if (errorBannerTranslations.loading) {
    return null;
  }

  const translations =
    errorBannerTranslations.data.application.translations.flightSearchForm;

  return (
    <Notification
      data-hook={ERROR_BANNER.hook}
      offsetTopPosition={offsetTopPosition}
    >
      <BillboardDisclaimerRow>
        <IconWrapper md={1} sm={1} xs={1}>
          <img src={icon} alt="error_icon" />
        </IconWrapper>
        <Col md={16} sm={23} xs={23}>
          <BillboardDisclaimerText>
            {errorMessage ? (
              <Text>{errorMessage}</Text>
            ) : (
              <>
                <Text>{translations.flightRouteUpdateWarning}</Text>
                <Text>{translations.flightRouteNotFoundError}</Text>
              </>
            )}
          </BillboardDisclaimerText>
        </Col>
      </BillboardDisclaimerRow>
    </Notification>
  );
};

ErrorBanner.propTypes = {
  icon: PropTypes.any,
  offsetTopPosition: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default withTheme(ErrorBanner);
